import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const SENTENCES_DOCTOR_ACTIVITY_FRAGMENT = gql `
  fragment SentenceDoctorActivityFragment on SentenceDoctorActivity {
    rounds {
      doctorImage {
        image {
          ...AssetFragment
        }
      }
      incorrectSentence
      selectList {
        answer
        isCorrect
      }
      textBubble {
        endText
        startText
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default SENTENCES_DOCTOR_ACTIVITY_FRAGMENT;
